// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-title[data-v-df95732a]{font-size:18px;font-weight:700!important;margin:0 0 2rem;padding-top:11px}.modal-close[data-v-df95732a]{background:transparent;border:none;display:block;-webkit-text-decoration:underline;text-decoration:underline}.modal-close[data-v-df95732a],p[data-v-df95732a]{text-align:center}p[data-v-df95732a]{margin:0 0 1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
